import { TITLE_RULE } from '@constants';

export const FORM_FIELD = {
  TITLE: {
    name: 'title',
    label: 'Post title:',
    rules: [{ required: true, message: 'Title is required' }, TITLE_RULE],
  },
  TEXT: {
    name: 'text',
    label: 'Post text:',
    rules: [{ required: true, message: 'Text is required' }],
  },
};
